module.exports = __webpack_public_path__ + "img/عمومی.6d135ac3.jpg";